import { Component } from 'preact'
import styled from 'styled-components';

const Wrapper = styled.div`
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: fixed;

    .outer { 
        animation: outer 1.5s ease-in-out infinite; 
    }

    svg {
        width: 30vw;
        height: 30vw;
        max-width: 200px;
        max-height: 200px;
    }

    circle { 
        fill: none; 
        stroke: #262525; 
        stroke-width: 1; 
    }

    @keyframes outer {
        0% { stroke-dasharray: 1,200; stroke-dashoffset: 0; }
        50% { stroke-dasharray: 89,200; stroke-dashoffset: -35; }
        100% { stroke-dasharray: 89,200; stroke-dashoffset: -124; }
    }

`

const MainWrapper = styled.div`
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background: #F8F7F5;
`
class LoadingIcon extends Component {

    render() {
        return (
            <MainWrapper>
                <Wrapper>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="25 25 50 50">
                        <circle className="outer" cx="50" cy="50" r="20">
                            <animateTransform attributeName="transform" dur="2s" from="0 50 50" repeatCount="indefinite" to="360 50 50" type="rotate" />
                        </circle>
                    </svg>
                </Wrapper>
            </MainWrapper>
        )

    }
}

export default LoadingIcon


// WEBPACK FOOTER //
// ./components/elements/Loading.js